import { createLaunchDarklyProviderContext } from '@sg/launch-darkly';

import { type FeatureFlags } from '../types';

export const LaunchDarklyProviderContext =
  createLaunchDarklyProviderContext<FeatureFlags>();
